<script setup lang="ts">
    import { ModelType } from '@/app/base/schemas/BaseSchema';
    import EndpointFactory from '@/app/factories/EndpointFactory';
    import InvoiceTemplate from '@/app/invoicing/models/InvoiceTemplate';

    const endpoint = EndpointFactory.make(ModelType.INVOICE_TEMPLATES);
    const { contextMenu, onAction, onPromise, hide } = useModelContextMenu();
    const deleteButton = ref(null);

    const destroy = async (model: InvoiceTemplate) => {
        await deleteButton.value.loadUntil(onPromise(endpoint.destroy(model.getId())));
    };
    const replicate = (model: InvoiceTemplate) => {
        hide();
        useEvent('invoicing:invoice-templates:replicate:open', model);
    };
</script>

<template>
    <ModelContextMenu
        v-slot="slotProps"
        ref="contextMenu"
        :model-type="InvoiceTemplate"
        :menu-height="100"
    >
        <LoadingButton
            :class-name="$theme('contextmenu.link')"
            @click.prevent="onAction(() => slotProps.model.edit())"
        >
            <i
                class="fa-pencil"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.edit') }}</span>
        </LoadingButton>
        <LoadingButton
            ref="replicateButton"
            :class-name="$theme('contextmenu.link')"
            @click.prevent="replicate(slotProps.model)"
        >
            <i
                class="fa-copy"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.replicate') }}</span>
        </LoadingButton>
        <LoadingButton
            ref="deleteButton"
            :class-name="$theme('contextmenu.link')"
            @click.prevent="destroy(slotProps.model)"
        >
            <i
                class="fa-trash"
                :class="$theme('contextmenu.icon')"
            ></i>
            <span>{{ $t('actions.delete') }}</span>
        </LoadingButton>
    </ModelContextMenu>
</template>
